// simple version of hex-rgb
export function hexToRgb(color: string, fallback: number[] = [0, 0, 0]): number[] {
  const hexMatch = color.match(/([\da-f]+)/i);
  let hex = hexMatch ? hexMatch[0] : '';

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  if (hex.length === 6) {
    const num = parseInt(hex, 16);
    return [num >> 16, (num >> 8) & 255, num & 255];
  }

  return fallback;
}
